import { getClasses } from '@/_utils/classnames';
import styles from './Counter.module.css';
import { type FC } from 'react';
import type { CounterProps } from './Counter.types';

export const Counter: FC<CounterProps> = ({
  allCount,
  isDisabled,
  doneCount,
  optionalCount = 0,
}) => {
  const requiredCount: number = allCount - optionalCount;
  const counterClasses: string = getClasses(styles.counter, {
    [styles.counterZero]: allCount === 0 && doneCount === 0,
    [styles.counterDone]: requiredCount <= doneCount,
    [styles.counterDisabled]: isDisabled,
  });

  return (
    <div className={counterClasses} data-component="Counter">
      {doneCount}
      <span>/</span>
      {allCount}
    </div>
  );
};
